export default props => ({
    background: props.theme.brand02,
    text: props.theme.brand01,
    hover: props.theme.hoverSecondary,
    hoverText: props.theme.hoverSecondaryText,
    radius: props.theme.atoms.button.radius,
    border: props.theme.brand01,
    focusBorder: props.theme.hoverSecondaryText,
    // Override with custom theme - this also defines the key under which
    // the theme can be overridden, in this case .automotive.configurationSummary
    // in general should follow the format .<domain>.<componentName>
    ...props.theme?.core?.secondaryButton
  });
